import { LicenseTester, Model } from "@mcleod/core";
import { ChangeEvent, LookupModelSearchEvent, DataSourceModeChangeEvent, DataSourceMode } from "@mcleod/components";
import { AutogenLayoutTriumphPayTxDetail } from "./autogen/AutogenLayoutTriumphPayTxDetail";
import { ModelDrsPayee } from "./models/ModelDrsPayee";

export class TriumphPayTxDetail extends AutogenLayoutTriumphPayTxDetail {
    sourceSettlementAfterModeChange(event: DataSourceModeChangeEvent) {
        if (this.mainDataSource.mode === DataSourceMode.SEARCH) {
            this.labelQuickPay.visible = false;
            this.labelTriumphpayQuickpay.visible = false;
            this.checkboxTriumphpayQuickpay.visible = true;
            this.textboxTriumphpayPymtStatus.lookupModelAllowMultiSelect = true;
        }
        if (this.mainDataSource.mode === DataSourceMode.UPDATE) {
            this.labelQuickPay.visible = true;
            this.labelTriumphpayQuickpay.visible = true;
            this.checkboxTriumphpayQuickpay.visible = false;
        }
    }

    textboxTriumphpayInvoiceStatusOnChange(event: ChangeEvent) {
        const isChangeToHold = this.textboxTriumphpayInvoiceStatus.selectedItem?.value === "3";
        this.textboxInvoiceStatusReason.visible = isChangeToHold;
        this.textboxInvoiceStatusReason.required = isChangeToHold;
        if (isChangeToHold) {
            this.textboxInvoiceStatusReason.clear();
        }
    }

    textboxTriumphpayPymtStatusBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.code_type = "TV";
    }

    hideNonDrsDeductFields() {
        this.textboxTriumphpayInvoiceStatus.visible = false;
        this.textboxTriumphpayPymtStatus.visible = false;
    }

    static async isTriumphPayActive(): Promise<boolean> {
        const isTriumphPayLicensed = LicenseTester.testPackage("com.tms.client.loadmaster.triumphpay");
        if (!isTriumphPayLicensed) {
            return false;
        }
        const triumphpayControlRow = await Model.searchSingleRecord("lme/dispatch/triumphpay-control");
        return triumphpayControlRow?.get("is_active", "N") === "Y";
    }

    static async isPayeeTriumphPay(payeeId: string): Promise<boolean> {
        if (!await this.isTriumphPayActive()) {
            return false;
        }
        const payee = await new ModelDrsPayee().searchSingle({ "id": payeeId });
        const paymentMethod = payee?.getString("payment_method", "N");
        return paymentMethod === "U";
    }
}
